import { useCustom } from '@refinedev/core';
import { AuthMethod } from 'src/auth/settings/types';

type PublicTenantConfig = {
  authMethod: AuthMethod;
};

export const usePublicTenantConfig = (tenantName: string | undefined) => {
  const { data, isLoading, isError, error } = useCustom<PublicTenantConfig>({
    url: `public/tenant-config/${encodeURIComponent(tenantName ?? '')}`,
    method: 'get',
    queryOptions: {
      enabled: !!tenantName,
      retry: false,
    },
  });

  return {
    config: data?.data ?? { authMethod: 'password' as const },
    isLoading,
    isError,
    error,
  };
};
